// extracted by mini-css-extract-plugin
export default {"megaDropdownMenu":"MobileNavbar_megaDropdownMenu__MmKuJ","browseWrapper":"MobileNavbar_browseWrapper__NLEy7"};